import React from 'react';
import { useContentfulSearchContent } from '@jbhi-fi/components/src/hooks/useContentfulSearchContent/useContentfulSearchContent';
import SearchContentResult from './SearchContentResult';
import { SearchContentTransformer } from '@jbhi-fi/components/src/Contentful/transformers/SearchContentTransformer';
import { ContentfulApiClient, ContentfulPreviewThemeApiClient } from '../../api/contentful/ContentfulClient';

const contentfulThemeApiClient = new ContentfulPreviewThemeApiClient();
const contentfulClient = new ContentfulApiClient();

export const SearchContentContainer = (searchTerm: { term: string }) => {
  const { searchContentResults = [] } = useContentfulSearchContent({
    contentfulThemeApiClient,
    contentfulClient,
    searchTerm,
  });
  const getTransformedSearchContentProps = () => {
    return SearchContentTransformer.toSearchContentProps(searchContentResults);
  };

  return <SearchContentResult searchResults={getTransformedSearchContentProps()} searchTerm={searchTerm?.term} />;
};
